<style lang="less">
  @import "./PickupServer.less";
</style>

<template>
  <div class="reserve-navigation">
    <!--<van-field v-model="bdSearchPlace" placeholder="可输入地点进行搜索" maxlength="30" class="reserve-navigation-search" id="picker-input" />-->
    <!--<ReserveNavigationBtn msg="Welcome to Your Vue.js App"/>-->
    <div id="reserve-map"></div>
    <div id="pickerBox" v-if="!loadingMap && pickupState===1">
      <input id="picker-input" class="reserve-navigation-picker" placeholder="可输入地点进行搜索" maxlength="30"/>
      <div id="poiInfo"></div>
    </div>
    <van-button type="info" size="large" @click="cancelConfirmFn" v-if="pickupState===3">我要取消</van-button>
  </div>
</template>

<script>
import PickupServer from './PickupServer.js'
export default {
  ...PickupServer
}
</script>
